import { render } from "./__Footer.vue?vue&type=template&id=a6fa17aa&scoped=true"
import script from "./__Footer.vue?vue&type=script&lang=js"
export * from "./__Footer.vue?vue&type=script&lang=js"

import "./__Footer.vue?vue&type=style&index=0&id=a6fa17aa&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a6fa17aa"]])

export default __exports__